import { NgModule } from "@angular/core";
import { sharedModule } from "src/app/shared/shared.module";
import { FormsModule } from "@angular/forms";
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ng2-currency-mask/src/currency-mask.config";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { StudentSessionsCheckoutComponent } from './student-sessions-checkout/student-sessions-checkout.component';
import { StudentListComponent } from './student-sessions-checkout/student-list/student-list.component';
import { RegisterMarkComponent } from './student-sessions-checkout/register-mark/register-mark.component';
import { DetailsMarkComponent } from './student-sessions-checkout/details-mark/details-mark.component';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  decimal: ".",
  precision: 0,
  prefix: " ",
  suffix: "",
  thousands: ","
};

@NgModule({
  declarations: [
  StudentSessionsCheckoutComponent,
  StudentListComponent,
  RegisterMarkComponent,
  DetailsMarkComponent
],
  imports: [sharedModule,FormsModule,CurrencyMaskModule],
  entryComponents: [
    StudentListComponent,
    RegisterMarkComponent,
    DetailsMarkComponent
  ],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
  ]
})
export class SessionsModule {}
